import React from 'react';

const coin = require("./img/claim-coin.png");

export const ClaimCoin = () => {
    return <img  src={coin} alt="coin" />
}